import React, { useState } from "react";
import { Button, message } from "antd";
import { propertyService } from "@iso/services";
import { SETUP_VARIANT } from "@iso/constants/onboarding";

const GetReadyStep = ({
  variant,
  propertyId,
  setupRequested,
  onSetupRequested,
  onNext,
  onGoToMap,
}) => {
  const [requesting, setRequesting] = useState(false);

  const handleRequestSetup = () => {
    setRequesting(true);
    propertyService
      .requestFreeSetup(propertyId)
      .then((res) => {
        setRequesting(false);
        if (res && res.code === "0000") {
          message.success(res.message || "Request sent");
          onSetupRequested();
        } else {
          message.error((res && (res.error || res.message)) || "Request failed");
        }
      })
      .catch(() => {
        setRequesting(false);
        message.error("Request failed. Please try again.");
      });
  };

  const isBusiness = variant === SETUP_VARIANT.BUSINESS;

  return (
    <>
      <h1 className="ob-title" tabIndex={-1}>
        {isBusiness
          ? "Get ready to start with AirAgri"
          : "Get ready to enter your property"}
      </h1>
      <p className="ob-lead">
        {isBusiness ? "Your business is" : "Your property is"} ready.
        If you'd like a hand getting set up, our team can help.
      </p>
      <div className="ob-option-list">
        <div className="ob-option">
          <div className="ob-option-text">
            <strong>Free setup service</strong>
            <span>
              Book a free onboarding call with one of our team. No extra
              details needed.
            </span>
          </div>
          <Button
            className="ob-option-btn"
            loading={requesting}
            disabled={setupRequested}
            onClick={handleRequestSetup}
          >
            {setupRequested ? "Requested" : "Request"}
          </Button>
        </div>
      </div>
      <div className="ob-actions">
        <Button className="ob-btn-primary" onClick={onNext}>
          Continue
        </Button>
        <button type="button" className="ob-link" onClick={onGoToMap}>
          Skip to property map
        </button>
      </div>
    </>
  );
};

export default GetReadyStep;
